// V22 FOUR-PILLAR NAVIGATION LOADER — UNPUBLISHED THEME CANDIDATE
(function () {
  'use strict';
  if (window.__sketchusNavV22Loader) return;
  window.__sketchusNavV22Loader = true;

  var current = document.currentScript;
  var source = current && current.src ? current.src : '';
  var marker = 'mobile-accordion.js';
  var index = source.indexOf(marker);
  if (index < 0) return;
  var base = source.slice(0, index);
  var failed = false;

  function failSafe() {
    failed = true;
    document.documentElement.classList.remove('sk-nav-v22');
  }

  function loadStylesheet(name, done) {
    var existing = document.querySelector('link[data-sk-v22="' + name + '"]');
    if (existing) { done(); return; }

    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = base + name + '?v=22';
    link.dataset.skV22 = name;
    link.onload = done;
    link.onerror = failSafe;
    document.head.appendChild(link);
  }

  function loadScript(name, done) {
    if (failed) return;
    var script = document.createElement('script');
    script.src = base + name + (name === 'sketchus-navigation-v22-core.js' ? '?v=20261024-native-routes' : '?v=20261015-en-menu');
    script.async = false;
    script.onload = done || function () {};
    script.onerror = failSafe;
    document.head.appendChild(script);
  }

  var stylesReady = 0;
  function afterStyle() {
    stylesReady += 1;
    if (stylesReady !== 2 || failed) return;
    loadScript('sketchus-navigation-v22-core.js', function () {
      loadScript('sketchus-navigation-v22-mobile.js');
    });
  }

  loadStylesheet('sketchus-navigation-v22-desktop.css', afterStyle);
  loadStylesheet('sketchus-navigation-v22-mobile.css', afterStyle);
})();
